/* DPO owns all calculation and currency conversion. Mirror its rendered prices only. */
if (!customElements.get('dpo-price-sync')) {
  customElements.define('dpo-price-sync', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('.section--main-product');
      if (!this.root) return;
      this.onPriceUpdate = () => this.sync();
      this.onPriceRendered = () => this.refresh();
      this.root.addEventListener('product:price-rendered', this.onPriceRendered);
      // DPO loads jQuery asynchronously. Bind before its first price event, or
      // refresh once if the plugin finished initializing before this component.
      if (!this.bind()) this.timer = setInterval(() => this.bind(), 250);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
      this.root?.removeEventListener('product:price-rendered', this.onPriceRendered);
      this.jQuery?.(window).off('dpoPriceUpdate', this.onPriceUpdate);
      this.jQuery = null;
    }

    bind() {
      if (!window.jQuery) return false;
      clearInterval(this.timer);
      this.jQuery = window.jQuery;
      this.jQuery(window).on('dpoPriceUpdate', this.onPriceUpdate);
      this.refresh(false);
      return true;
    }

    refresh(resetBase = true) {
      const panel = this.root.querySelector('#itoris_dynamicproductoptions');
      const dpo = window.dpoOptions;
      if (!panel) return;
      // Same invalidation used by DPO's own variant-change handler. Do this
      // after Taiga has replaced its price markup, not on the earlier change.
      if (resetBase) panel.dpoProductInitialPrices = false;
      if (dpo?.isInit && typeof dpo.updatePrice === 'function') dpo.updatePrice(true);
      this.sync();
    }

    sync() {
      if (!this.root.querySelector('#itoris_dynamicproductoptions')) return;
      const sectionId = this.dataset.sectionId;
      const source = document.getElementById(`price-${sectionId}`)?.querySelector('.price');
      const target = document.getElementById(`price-${sectionId}-product-buy-bar`)?.querySelector('.price');
      if (!source || !target || !this.root.contains(source) || !this.root.contains(target)) return;

      target.classList.toggle('price--on-sale', source.classList.contains('price--on-sale'));
      // Preserve the sticky layout, accessible labels, currency markup and
      // unit prices. In particular, never copy DPO's main-price selectors.
      for (const selector of ['.price__regular .price-item', '.price__sale s', '.price__sale .price-item--sale']) {
        const from = source.querySelector(selector);
        const to = target.querySelector(selector);
        if (!from || !to) continue;
        if (to.innerHTML !== from.innerHTML) to.innerHTML = from.innerHTML;
        to.classList.toggle('dpo-hidden', from.classList.contains('dpo-hidden'));
      }
    }
  });
}
